module.exports = __webpack_public_path__ + "static/marbl-dd3f522f7df54a2919a8fde1083d6e34.mp4";